import { BACKEND_APIS, SERVICES_TYPE } from '@constants'
import {tabSelected} from "../../../Admin/GlobalExecution/@signals";
import {GLOBAL_EXECUTION_TABS} from "../../../Admin/GlobalExecution/@constants";

export default function useReportBackendApiPath( isExtras = false ) {
	const isExtra = isExtras || window.location.pathname.includes('extra')
	const isBatch = window.location.pathname.includes('batch') || tabSelected.value === GLOBAL_EXECUTION_TABS.BATCHES
	return {
		multipleStatus: isExtra ? `${BACKEND_APIS.REPORT_EXTRA}/status-multiple` : `${BACKEND_APIS.REPORTS}/status-multiple`,
		backendUrl: isExtra ? BACKEND_APIS.REPORT_EXTRA : BACKEND_APIS.REPORTS,
		backendService: isExtra ? SERVICES_TYPE.REPORTS_EXTRA : SERVICES_TYPE.REPORTS,
		searchUrl: BACKEND_APIS.SEARCH,
		searchesUrl: isExtra ? `${BACKEND_APIS.REPORT_EXTRA}/status-per-office` : isBatch ? `${BACKEND_APIS.BATCH}/status-per-office` : `${BACKEND_APIS.REPORTS}/status-per-office`,
		searchesBySiteUrl: isExtra ? `${BACKEND_APIS.REPORT_EXTRA}/status-per-site` : isBatch ? `${BACKEND_APIS.BATCH}/status-per-site` : `${BACKEND_APIS.REPORTS}/status-per-site`,
		reportType: isExtra ? 'extras' : isBatch ? 'batch' : '',
		historic: isExtra ? `${BACKEND_APIS.REPORT_EXTRA}/executions` : `${BACKEND_APIS.REPORTS}/executions`,
		forceUrl: isExtra ? `${BACKEND_APIS.INTERMEDIARY}/check/executions/reports-extras/force` : `${BACKEND_APIS.INTERMEDIARY}/check/executions/report/force`,
	}
}